import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from './settings';
import { ResponseModel } from '../models/response-model';

@Injectable({
  providedIn: 'root'
})
export class LoginService { 
  private rutaApi:string = AppSettings.apiEndpoint;
  private path:string = "";
  private produccion:boolean = AppSettings.produccion;

  private isLoggedInFlag: boolean = false;
  permisos_usuario: string[] = [];
  
  
  constructor(private http:HttpClient){
    if(this.isLoggedIn()){
      this.setearUsuario();
    }
  }

  // Método para verificar si el usuario está autenticado
  isLoggedIn(): boolean {
    sessionStorage.getItem('t')? this.isLoggedInFlag=true : this.isLoggedInFlag=false;
    return this.isLoggedInFlag;
  }

  tienePermisos(permiso: string): boolean {
    this.setearUsuario();
    return this.permisos_usuario.includes(permiso);
  }

    // Método para verificar si el usuario tiene uno de los permisos a pantallas
  verificarPermisos(rolesUsuario: string[]): boolean {

    // Verifica si el usuario está logueado
    if (!this.isLoggedInFlag) {
      return false; // Si el usuario no está logueado, no tiene ningún permiso
    }
    this.setearUsuario();
    // Simulemos que el usuario actual tiene roles almacenados en un array llamado 'userRoles'
    // Verifica si al menos uno de los roles especificados se encuentra en los roles del usuario actual
    const hasRole = rolesUsuario.some(role => this.permisos_usuario.includes(role));
 
    return hasRole;
  }


  setearUsuario(){ 
    this.permisos_usuario=[];

    if(sessionStorage.getItem('HPOCP') == 'S'){
      this.permisos_usuario.push('HPOCP');
    }

    if(sessionStorage.getItem('HMCP') == 'S'){
      this.permisos_usuario.push('HMCP');
    }

    if(sessionStorage.getItem('HBSPDF') == 'S'){
      this.permisos_usuario.push('HBSPDF');
    }
  
  }


  async recover(cliente:string,usuario:string) {
    this.path = "";
    if(cliente==null){ cliente=''; }
    if(usuario==null){ usuario=''; }

    if(cliente==='' || usuario ===''){ return new ResponseModel("1","Debe completar ambos CUIT"); }

      if(this.produccion){ this.path = this.rutaApi+'recuperar_contra.php';}
      else { this.path = '/api/recover'; }

      const params={
        'login'        :'S',
        'cliente'      : cliente,
        'cuit_usuario' : usuario}

       const headers = new HttpHeaders({ 'Content-Type': 'application/json'}); //T0D0 GENERALIZAR
       let response = await this.http.post<ResponseModel>(this.path,params,{headers}).toPromise();

    return response;
  }

  async login(cliente:string,usuario:string,password:string) {
    this.path = "";
    if(cliente==null){ cliente=''; }
    if(usuario==null){ usuario=''; }
    if(password==null){ password=''; }
    if(cliente==='' || usuario ==='' || password ===''){ return new ResponseModel("1","Debe completar todos los datos"); }

    if(this.produccion){ this.path = this.rutaApi+'consultar_usuario.php';}
        else { this.path = '/api/login'; }

    const params={
      'login'        :'S',
      'cliente'      : cliente,
      'cuit_usuario' : usuario,
      'clave_usuario' : password}

      const headers = new HttpHeaders({ 'Content-Type': 'application/json'});
    let response = await this.http.post<any>(this.path,params,{headers}).toPromise();

    if(response[0].mensaje!==null){ return new ResponseModel("1",response[0].mensaje); }
      else{
      localStorage.setItem('cuenta',response[0].nro_cuenta);
      localStorage.setItem('usuario',response[0].cuit_usuario);
      localStorage.setItem('nombre',response[0].nombre);
      localStorage.setItem('nro_cliente',response[0].nro_cliente);
      localStorage.setItem('nro_proveedor',response[0].nro_proveedor);
      localStorage.setItem('razon',response[0].razon);}
      response[0].t? sessionStorage.setItem('t',response[0].t): null;
 
      if(response[0].HABILITAR_PANTALLA_OC_PENDIENTE && response[0].HABILITAR_PANTALLA_OC_PENDIENTE=='S'){
        sessionStorage.setItem('HPOCP','S');
      } 

      if(response[0].HABILITAR_BOTON_SUBIR_PDF && response[0].HABILITAR_BOTON_SUBIR_PDF=='S'){
        sessionStorage.setItem('HBSPDF','S');
      } 

      if(response[0].HABILITAR_MENU_COMPROBANTES_PROVEEDORES && response[0].HABILITAR_MENU_COMPROBANTES_PROVEEDORES=='S'){
        sessionStorage.setItem('HMCP','S');
      } 

      return  new ResponseModel("0", response[0].nombre);
  }

}

